module.exports = __webpack_public_path__ + "static/media/AVCfrontdesk.1213811a.svg";